import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-selected\">\n<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#1E49E2\" />\n<path d=\"M9.65138 5.5L6.15138 9L4 6.84862\" stroke=\"white\" stroke-width=\"0.571429\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol